import type { HelpFile } from '../../types/help'
import { RequestInspectorTestIds } from '../../../testids/RequestInspectorTestIds'

export const requestInspectorHelp: HelpFile = {
  docPage: '/docs/admin/request-inspector',
  texts: {
    [RequestInspectorTestIds.requestInspectorPage]:
      'Recorded request sessions — each row groups all HTTP, SQL, frontend, and service-call spans under one session ID for end-to-end tracing.',
    [RequestInspectorTestIds.requestInspectorList]:
      'Free-text search matches operation names and HTTP URLs only — diagnostic columns are deliberately excluded.',
    [RequestInspectorTestIds.tracesTable]:
      'One row per recorded session — click to open the full span waterfall.',
    [RequestInspectorTestIds.colSessionId]: 'Session ID shared by all spans captured during the same user request.',
    [RequestInspectorTestIds.colEarliestStartedAt]: 'Timestamp of the first span — when the request began.',
    [RequestInspectorTestIds.colTotalDuration]: 'Wall-clock time from the first span starting to the last span ending.',
    [RequestInspectorTestIds.colSpanCount]: 'Number of spans recorded — higher counts often indicate fan-out or N+1 patterns.',
    [RequestInspectorTestIds.colErrorCount]: 'Number of spans that recorded an error.',
    [RequestInspectorTestIds.pageLayoutFilters]: null,
    [RequestInspectorTestIds.inspectorMinQHint]: 'Free-text search requires at least three characters before querying the database.',
    [RequestInspectorTestIds.inspectorSearchScopeHint]: 'Search matches operation names and HTTP URLs only — diagnostic fields are excluded by design.',
    [RequestInspectorTestIds.writerOfflineAlert]: 'The trace writer is offline — new sessions are not being recorded.',
    [RequestInspectorTestIds.emptyStateCard]: 'No request sessions match the current filters.',
  },
}
